import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
// AVATARS IMPORTS
import avatar1 from "../images/avatars/avatar-1.png";
import avatar2 from "../images/avatars/avatar-2.png";
import avatar3 from "../images/avatars/avatar-3.png";
import avatar4 from "../images/avatars/avatar-4.png";
import avatar5 from "../images/avatars/avatar-5.png";
import avatar6 from "../images/avatars/avatar-6.png";

const TestimonialsCarousel = () => {
  return (
    <Carousel
      showArrows={true}
      infiniteLoop={true}
      showThumbs={false}
      showStatus={false}
      autoPlay={true}
      interval={3000}
    >
      <>
        <img src={avatar4} alt="Blind Draw" />
        <div className="myCarousel">
          <h3>Blind Draw</h3>
          <p>
            Draw blindly, then reveal the results! A fun <b>drawing challenge</b> with <b>750 levels</b> and free draw mode.
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/il/app/blind-draw/id6760413557" target="_blank" rel="noopener noreferrer">iOS</a>
            {" | "}
            <a href="https://play.google.com/store/apps/details?id=com.myapps.myappsgame2" target="_blank" rel="noopener noreferrer">Android</a>
          </div>
        </div>
      </>
      <>
        <img src={avatar5} alt="Cast & Mirror" />
        <div className="myCarousel">
          <h3>Cast & Mirror</h3>
          <p>
            <b>Cast to TV & screen mirror</b> your phone in seconds. Share photos, videos, and files on the big screen.
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/us/app/cast-to-tv-screen-mirror/id6759862148" target="_blank" rel="noopener noreferrer">iOS</a>
            {" | "}
            <a href="https://play.google.com/store/apps/details?id=com.myapps.remoteforthomson" target="_blank" rel="noopener noreferrer">Android</a>
          </div>
        </div>
      </>
      <>
        <img src={avatar6} alt="Remote for Xiaomi" />
        <div className="myCarousel">
          <h3>Remote for Xiaomi</h3>
          <p>
            Control your <b>Xiaomi smart TV</b> directly from your phone. Easy setup, smooth experience.
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/us/app/remote-for-xiaomi/id6755174924" target="_blank" rel="noopener noreferrer">iOS</a>
            {" | "}
            <a href="https://play.google.com/store/apps/details?id=com.matanyamin.remoteforxiaomi" target="_blank" rel="noopener noreferrer">Android</a>
          </div>
        </div>
      </>
      <>
        <img src={avatar2} alt="Tinger" />
        <div className="myCarousel">
          <h3>Tinger</h3>
          <p>
            A fast-paced <b>maze game</b>. Navigate tunnels, dodge obstacles, and beat high scores!
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/us/app/tinger/id6746838060" target="_blank" rel="noopener noreferrer">iOS</a>
            {" | "}
            <a href="https://play.google.com/store/apps/details?id=com.matanyamin.tinger" target="_blank" rel="noopener noreferrer">Android</a>
          </div>
        </div>
      </>
      <>
        <img src={avatar1} alt="Remote for LG" />
        <div className="myCarousel">
          <h3>Remote for LG</h3>
          <p>
            The best <b>AC remote app</b> for LG users. Simple, reliable, and used by <b>millions worldwide</b>.
          </p>
          <div className="store-links">
            <a href="https://play.google.com/store/apps/details?id=com.matanyamin.lgacremotecontrol" target="_blank" rel="noopener noreferrer">Android</a>
          </div>
        </div>
      </>
      <>
        <img src={avatar3} alt="Remote for ChromeCast" />
        <div className="myCarousel">
          <h3>Remote for ChromeCast</h3>
          <p>
            Control your <b>Chromecast</b> from your phone. Manage streaming, volume, and settings with ease.
          </p>
          <div className="store-links">
            <a href="https://apps.apple.com/us/app/remote-for-chromecast-googletv/id6736590014" target="_blank" rel="noopener noreferrer">iOS</a>
            {" | "}
            <a href="https://play.google.com/store/apps/details?id=com.matanyamin.remoteforchromecast" target="_blank" rel="noopener noreferrer">Android</a>
          </div>
        </div>
      </>
    </Carousel>
  );
};

export default TestimonialsCarousel;
